import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "package",
  "use": "package-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"package\">\r\n<path d=\"M2 2.48L2 13.52C2 13.7855 2.2145 14 2.48 14L13.52 14C13.7855 14 14 13.7855 14 13.52L14 2.48C14 2.2145 13.7855 2 13.52 2L2.48 2C2.2145 2 2 2.2145 2 2.48ZM8.96 3.08L8.96 7.76L7.04 7.76L7.04 3.08L8.96 3.08ZM12.92 3.08L12.92 12.92L3.08 12.92L3.08 3.08L6.08 3.08L6.08 8.24C6.08 8.5055 6.2945 8.72 6.56 8.72L9.44 8.72C9.7055 8.72 9.92 8.5055 9.92 8.24L9.92 3.08L12.92 3.08Z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol